module.exports = __webpack_public_path__ + "img/row3_col1.4ac8ffe6.svg";